// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__YF2jZ","footer":"ModalFilter_footer__N0znO"};